import React from "react"
import types from "prop-types"
import LocationAnswerFiltersLocationDetailsSelectedFacilityDepartments from "./LocationAnswerFiltersLocationDetailsSelectedFacilityDepartments"

const LocationAnswerFiltersLocationDetailsSelectedFacilities = ({ selectedFacilityIds }) => (
  <>
    {
      selectedFacilityIds.map((facilityId) => (
        <LocationAnswerFiltersLocationDetailsSelectedFacilityDepartments
          key={facilityId}
          className="mb-4 last:mb-0"
          selectedFacilityId={facilityId}
        />
      ))
    }
  </>
)

LocationAnswerFiltersLocationDetailsSelectedFacilities.propTypes = {
  selectedFacilityIds: types.arrayOf(types.number).isRequired,
}

export default LocationAnswerFiltersLocationDetailsSelectedFacilities
